var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectJobsXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 17.3337C4.39758 17.3337 0.666748 13.6028 0.666748 9.00033C0.666748 4.39783 4.39758 0.666992 9.00008 0.666992C13.6026 0.666992 17.3334 4.39783 17.3334 9.00033C17.3334 13.6028 13.6026 17.3337 9.00008 17.3337ZM9.00008 15.667C10.7682 15.667 12.4639 14.9646 13.7141 13.7144C14.9644 12.4641 15.6667 10.7684 15.6667 9.00033C15.6667 7.23222 14.9644 5.53652 13.7141 4.28628C12.4639 3.03604 10.7682 2.33366 9.00008 2.33366C7.23197 2.33366 5.53628 3.03604 4.28604 4.28628C3.03579 5.53652 2.33341 7.23222 2.33341 9.00033C2.33341 10.7684 3.03579 12.4641 4.28604 13.7144C5.53628 14.9646 7.23197 15.667 9.00008 15.667ZM9.00008 7.82199L11.3567 5.46449L12.5359 6.64366L10.1784 9.00033L12.5359 11.357L11.3567 12.5362L9.00008 10.1787L6.64341 12.5362L5.46425 11.357L7.82175 9.00033L5.46425 6.64366L6.64341 5.46449L9.00008 7.82199Z",
    fill: "#A1B3C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectJobsXIcon);
export default __webpack_public_path__ + "static/media/project-jobs-x-icon.5ffed9c5d4e410ba8e523ed0b4379f75.svg";
export { ForwardRef as ReactComponent };